import { FC } from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';

interface Props {
    message: string;
}

export const StepLoading: FC<Props> = ({ message }) => {
    return (
        <Box display="flex" alignItems="center" justifyContent="center" minHeight={240}>
            <Stack spacing={2} alignItems="center">
                <CircularProgress />
                <Typography variant="body2" color="text.secondary">
                    {message}
                </Typography>
            </Stack>
        </Box>
    );
};
